"use strict";

const _ = require('lodash');
const CSS_TOKEN = /\b(\S+)\b/g;

class CSSList {
	constructor(css, ... args) {
		this._tokens = new Set();
		this.add(css, ... args);
	}

	get tokens() {
		return this._tokens;
	}

	get css() {
		let r = Array.from(this._tokens).filter(_.identity);
		r.sort();
		return r.join(' ');
	}

	add(css, ... args) {
		// Separate case - when the first argument is a function
		if (_.isFunction(css)) {
			return this.add(css(... args));
		}

		if (Array.isArray(css)) {
			this.add(... css);
			return this;
		}

		if (_.isObject(css)) {
			for (let k of Object.keys(css)) {
				if (css[k]) {
					this.add(k);
				} else {
					this.remove(k);
				}
			}
			return this;
		}

		if (!css) {
			return this;
		}

		css = String(css);
		let match;
		while ((match = CSS_TOKEN.exec(css))) {
			this._tokens.add(match[0]);
		}
		return this;
	}

	remove(css, ... args) {
		css = new CSSList(css, ... args);
		for (let token of css.tokens) {
			this._tokens.delete(token);
		}
		return this;
	}

	toggle(css, ... args) {
		css = new CSSList(css, ... args);
		for (let token of css.tokens) {
			if (this._tokens.has(token)) {
				this._tokens.remove(token);
			} else {
				this._tokens.add(token);
			}
		}
	}

	valueOf() {
		return this.css;
	}

	toString() {
		return this.css;
	}

	apply(el) {
		el.setAttribute('class', this.css);
	}

	addTo(el) {
		el.classList.add(... this._tokens);
		return el;
	}

	removeFrom(el) {
		el.classList.remove(... this._tokens);
		return el;
	}

	toggleOn(el) {
		for (let t of this._tokens) {
			el.classList.toggle(t);
		}
		return el;
	}
}

function css(css, ... args) {
	return (new CSSList(css, ... args)).css;
}

module.exports = {css, CSSList};
